export type ParamWithLab<L> = { lab: L };

/** Distinct labs appearing in a list of parameters, keyed by lab.id. */
export const getUniqueLabs = <L extends { id: string }>(params: readonly ParamWithLab<L>[]): L[] => {
  const byId = new Map<string, L>();
  for (const p of params) {
    if (!byId.has(p.lab.id)) {
      byId.set(p.lab.id, p.lab);
    }
  }
  return [...byId.values()];
};
